export const COMMON_MODAL_STYLES = {
  borderRadius: '20px',
  minWidth: '320px',
  width: 'clamp(320px, 33.33vw, 640px)',
  maxWidth: 'calc(100vw - 32px)',
  maxHeight: 'calc(100vh - 80px)',
  height: 'calc(100vh - 80px)',
  marginTop: '40px',
  marginBottom: '40px',
  selectors: {
    '@media (max-width: 500px)': {
      width: '100vw',
      minWidth: 0,
      maxWidth: 'none',
      borderRadius: '20px'
    },
    '@media (max-height: 500px)': {
      height: '100vh',
      maxHeight: 'none',
      borderRadius: 0,
      marginTop: 0,
      marginBottom: 0
    },
    '@media screen and (max-device-width: 640px)': {
      width: '100vw',
      minWidth: 0,
      maxWidth: 'none'
    }
  }
};
